import { render, staticRenderFns } from "./RoleTaskPermissions.vue?vue&type=template&id=72d03ece&scoped=true&"
import script from "./RoleTaskPermissions.vue?vue&type=script&lang=js&"
export * from "./RoleTaskPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d03ece",
  null
  
)

export default component.exports